import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'

function MfActivity() {
    const { BaseURL } = useContext(URLstateContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [DataActivites, setDataActivites] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getDataActivites;
    let PageSize = 5;
    let navigate = useNavigate();
    useEffect(() => {
        setloadingshow(true);
        const getUrlMfActivites = BaseURL + "MFActivites";
        fetch(`${getUrlMfActivites}/6`)
            .then((response) => response.json())
            .then((dataMfactivites) => {
                getDataActivites = dataMfactivites.data;
                setDataActivites(getDataActivites);
                setloadingshow(false);
                // console.log(getDataActivites, "MFActivites")
            })
            .catch((error) => {
            });

    }, []);
    const currentTableDataMfActivite = useMemo(() => {
        if (DataActivites != null && DataActivites != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataActivites != null && DataActivites != []) {
                if (DataActivites.length > 0) {
                    return DataActivites.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataActivites]);
    return (
        <>

            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>Mutual Fund Activity</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/Mutual-Fund-Activities")}}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='mf-common'>
                        <div className='mf-table table-responsive gainer-table tr-main'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-right'>As on Date</th>
                                        <th className='text-left'>Equity/Debt</th>
                                        <th className='text-left'>Gross Purchase(&#8377;)</th>
                                        <th className='text-left'>Gross Sale(&#8377;)</th>
                                        <th className='text-left'>Net Purchase(&#8377;)</th>
                                    </tr>
                                </thead>
                                {(DataActivites === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                <tbody>
                                    {(DataActivites != null) && DataActivites.map(
                                        ({ TRANS_DATE, EQ_GR_PURC, EQ_GR_SALE, EQ_G_NE_PS, DE_GR_PURC, DE_GR_SALE, DB_G_NE_PS }) => (
                                            <tr className="tr-inner-main">
                                                <td>
                                                    <table className='table'>
                                                        <tbody>
                                                            <tr>
                                                                <td className="text-right">
                                                                    {format(parseISO(TRANS_DATE.split('T')[0]), 'dd-MMM-yyyy')}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-right">
                                                                    &nbsp;
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td>
                                                    <table className='table'>
                                                        <tbody><tr>
                                                            <td className="text-left">
                                                                Equity
                                                            </td>
                                                        </tr>
                                                            <tr>
                                                                <td className="text-left">
                                                                    Debt
                                                                </td>
                                                            </tr>
                                                        </tbody></table>
                                                </td>
                                                <td>
                                                    <table className='table'>
                                                        <tbody><tr>
                                                            <td className="text-right">
                                                                {EQ_GR_PURC.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                            <tr>
                                                                <td className="text-right">
                                                                    {DE_GR_PURC.toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        </tbody></table>
                                                </td>
                                                <td>
                                                    <table className='table'>
                                                        <tbody><tr>
                                                            <td className="text-right">
                                                                {EQ_GR_SALE.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                            <tr>
                                                                <td className="text-right">
                                                                    {DE_GR_SALE.toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        </tbody></table>
                                                </td>
                                                <td>
                                                    <table className='table'>
                                                        <tbody><tr>
                                                        <td><p className={EQ_G_NE_PS.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}>
                                                             {EQ_G_NE_PS != null ? EQ_G_NE_PS.toFixed(2) : 0} </p></td>
                                                            
                                                        </tr>
                                                            <tr>
                                                            <td><p className={DB_G_NE_PS.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> 
                                                            {DB_G_NE_PS != null ? DB_G_NE_PS.toFixed(2) : 0} </p></td>
                                                                
                                                            </tr>
                                                        </tbody></table>
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            {/* {(DataActivites != null && DataActivites != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(DataActivites.length != null) ? DataActivites.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                        </div>
                    </div>
                </Container>
            </div>

        </>
    )
}

export default MfActivity